import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Select from 'orionsoft-parts/lib/components/fields/Select'

export default function Area({zoneId, zonesIds, ...props}) {
  const {areas} = useQuery({
    query: gql`
      query getAreas($zoneId: ID, $zonesIds: [ID]) {
        areas(zoneId: $zoneId, zonesIds: $zonesIds) {
          value: _id
          label: name
        }
      }
    `,
    variables: {
      ...(zoneId ? {zoneId} : {}),
      ...(zonesIds ? {zonesIds} : {})
    }
  })

  return <Select placeholder="Selecciona una area" {...props} options={areas} />
}
